var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAreaMeasure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 25",
    style: {
      enableBackground: "new 0 0 30 25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "map-draw-pin-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,9v1h5.219l0.484,1.936C23.6,12.389,21.705,12.951,20,13.587v1.096c1.763-0.688,3.731-1.297,5.945-1.776l0.585,2.338 c-1.798,1.602-4.274,4.423-5.9,8.754h-7.204c-0.907-1.281-2.046-2.277-3.283-3.029c1.599-1.625,3.825-3.396,6.857-4.947v-1.149 c-3.539,1.719-6.061,3.736-7.813,5.572c-2.405-1.214-4.949-1.672-6.558-1.841l0.632-2.527c4.533-1.183,6.233-4.088,6.86-6.078H17V9 H4L0,25h30L26,9H20z M4.781,10h4.317c-0.58,1.655-2.017,3.889-5.56,4.974L4.781,10z M1.281,24l1.102-4.406 c1.451,0.151,3.825,0.556,6.089,1.637C7.563,22.278,6.908,23.232,6.449,24H1.281z M7.664,24c0.439-0.661,1.022-1.435,1.767-2.267 c1.01,0.588,1.962,1.329,2.752,2.267H7.664z M28.719,24h-7.005c1.438-3.603,3.491-6.096,5.099-7.626L28.719,24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,18h1V6.95c0.353-0.051,0.688-0.151,1-0.299c1.18-0.563,2-1.757,2-3.15C22,1.567,20.434,0,18.5,0 C16.566,0,15,1.567,15,3.5c0,1.394,0.82,2.587,2,3.15c0.311,0.148,0.646,0.248,1,0.299V18z M16,3.5C16,2.119,17.119,1,18.5,1 C19.881,1,21,2.119,21,3.5S19.881,6,18.5,6C17.119,6,16,4.881,16,3.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAreaMeasure);
export default __webpack_public_path__ + "static/media/areaMeasure.5556ca0e89ba02711b296a47de6044ff.svg";
export { ForwardRef as ReactComponent };